import React from 'react';

export default function SquaresOIcon() {
  return (
  	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="1" width="6" height="6" rx="1.5" stroke="#111418"/>
      <rect x="8.75" y="1" width="6" height="6" rx="1.5" stroke="#111418"/>
      <rect x="8.75" y="9" width="6" height="6" rx="1.5" stroke="#111418"/>
      <rect x="0.75" y="9" width="6" height="6" rx="1.5" stroke="#111418"/>
    </svg>
  );
}
